import React from 'react'
import { withRouter } from "react-router"
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik'
import { WEISCHER_INTERSCROLLER, WEISCHER_OVERVIEW, WEISCHER_PREROLL } from '../../constants/weischerTypes';
import FieldWrapper from '../forms/FieldWrapper';
import { sanitizeFormInput, sanitizeFormOutput } from '../../functions/formFunctions';
import MultiselectCheckboxCinemas from '../forms/fields/MultiselectCheckboxCinemas';
import sortCinemas from '../../functions/sortCinemas';
import ImageDisplayAndUpload from '../forms/fields/ImageDisplayAndUpload';
import Translation from '../Translation/cont/Translation';
import RadioButtonGroup from '../forms/fields/RadioButtonGroup';
import RadioButton from '../forms/fields/SingleSelectRadiobutton';
import attributeConfig from '../../attribute-position-config.json'
import addFormikData from '../../functions/addFormikData';

const FormWeischerData = ({item, type, onUpdateItem, cliCinemas, clientCinemaId}) => {
    const textFieldLabelTransId = type === WEISCHER_PREROLL ? 'weischer_preroll_vast_xml_before_movietrailer' : 'weischer_promotional_id'
    const checkboxLabelTransId = type === WEISCHER_PREROLL ? 'weischer_preroll_active_all_trailers' : 'weischer_item_active'
    const cliCinemasIdList = sortCinemas(clientCinemaId, cliCinemas)
    const cinemaDomain = cliCinemas[clientCinemaId] && cliCinemas[clientCinemaId].website
    const {destinationType, pathType} = attributeConfig
    const newLinkData = {
        destinationType: "internal",
        pathType: "absolute",
        url: "",
        text: ""
    }
    const linkData = item && item.fallbackLink ? item.fallbackLink : newLinkData

    return (
        <Formik
            initialValues={addFormikData(sanitizeFormInput(item, cliCinemas), linkData, "fallbackLink")}
            validateOnBlur={false}
            onSubmit={(values, actions) => {
                values.type = type
                console.log(values)
                if(!values.fallbackLink.url) {
                    addFormikData(values, "", "fallbackLink")
                }
                onUpdateItem(values.pk, sanitizeFormOutput(values))
            }}
        >
        {({ values, errors, status, touched, isSubmitting, handleReset, handleChange, handleBlur, submitForm }) => (
                <Form>
                    <fieldset className="weischer-ad-element-wrapper">
                        <div>
                            <FieldWrapper label={<Translation id={textFieldLabelTransId}/>} id="content-title" classes="field-text">
                                <Field type="text" name="payload" id="content-title" onBlur={(e) => {handleBlur(e); submitForm();}} className="text-regular input-text-box" />
                                <ErrorMessage className="text-regular-color" name="payload" component="div" /> 
                            </FieldWrapper>
                            {type !== WEISCHER_PREROLL && type !== WEISCHER_OVERVIEW && type !== WEISCHER_INTERSCROLLER && <>
                                <FieldWrapper classes="image" label={<Translation id="weischer_picture_element"/>} id="content-image" >
                                    <Field 
                                        name="fallbackImage"
                                        onChange={() => {submitForm();}}
                                        component={ImageDisplayAndUpload}
                                    />
                                </FieldWrapper>
                                <>
                                    <FieldWrapper label={<Translation id="content_link_url"/>} id="content-link-url" classes="field-text gap-20">
                                        <Field type="text" name="fallbackLink.url" id="content-link-url" onBlur={(e) => {handleBlur(e); submitForm();}} className="text-regular input-text-box" />
                                        <ErrorMessage name="fallbackLink.url" component="div" /> 
                                    </FieldWrapper>
                                    <RadioButtonGroup
                                        label={<Translation id="content_link_target"/>}
                                        description={<Translation id="content_link_target_info"/>}
                                        className="gap-20 select-new-section-type"
                                    >
                                        <ErrorMessage className="text-regular-color movie-error" name="fallbackLink.destinationType" component="div" /> 
                                        {destinationType.map(type => {
                                            const {transId, id} = type
                                            return (
                                                <Field
                                                    key={id}
                                                    component={RadioButton}
                                                    name="fallbackLink.destinationType"
                                                    id={id}
                                                    submitFormFunc={submitForm}
                                                    label={<Translation id={transId}/>}
                                                />
                                            )
                                        })}
                                    </RadioButtonGroup>
                                    <RadioButtonGroup
                                        label={<Translation id="content_link_type"/>}
                                        description={<Translation id="content_link_type_info" after={' ' + cinemaDomain}/>}
                                        className="gap-20 select-new-section-type"
                                    >
                                        <ErrorMessage className="text-regular-color movie-error" name="fallbackLink.pathType" component="div" /> 
                                        {pathType.map(type => {
                                            const {transId, id} = type
                                            return (
                                                <Field
                                                    key={id}
                                                    component={RadioButton}
                                                    name="fallbackLink.pathType"
                                                    id={id}
                                                    submitFormFunc={submitForm}
                                                    label={<Translation id={transId}/>}
                                                />
                                            )
                                        })}
                                    </RadioButtonGroup>
                                </>
                            </>}
                            {_.has(values, "cinema") && cliCinemas ? (
                                cliCinemasIdList.length > 1 ? (
                                    <fieldset className="field-cinemas">
                                        <legend className="field-text-label"><Translation id="cinemas">Kinos</Translation></legend>

                                        <div className="select-all-cinemas-button-wrapper">  
                                            <div key={'field-all'} className="field-checkbox">
                                                <Field 
                                                    key={'all'} 
                                                    attrid={'all'}
                                                    name="cinemas"
                                                    component={MultiselectCheckboxCinemas} 
                                                    id={'alle anwählen'}
                                                    clicinemas={'all'}
                                                    value={cliCinemasIdList} 
                                                    instantSubmit={true}
                                                    handleChangeFunc={handleChange}
                                                    submitFormFunc={submitForm}
                                                />
                                            </div>
                                        </div>

                                        <div className="grid-container">
                                            {cliCinemasIdList.map(cinemaId => {
                                                const cinema = cliCinemas[cinemaId]
                                                const {pk, nameShort} = cinema

                                                return (
                                                    <div key={'field' + pk} className="field-checkbox">
                                                        <Field 
                                                            key={pk} 
                                                            attrid={pk}
                                                            name="cinemas"
                                                            component={MultiselectCheckboxCinemas} 
                                                            id={nameShort}
                                                            clicinemas={cliCinemas}
                                                            value={pk} 
                                                            instantSubmit={true}
                                                            handleChangeFunc={handleChange}
                                                            submitFormFunc={submitForm}
                                                        />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </fieldset>
                                ) : (
                                    cliCinemasIdList.map(cinemaId => {
                                        const cinema = cliCinemas[cinemaId]
                                        const {pk, nameShort} = cinema

                                        return (
                                            <div key={'field' + pk} className="field-checkbox">
                                                <Field 
                                                    key={pk} 
                                                    attrid={pk}
                                                    name="cinemas"
                                                    component={MultiselectCheckboxCinemas} 
                                                    id={nameShort}
                                                    clicinemas={cliCinemas}
                                                    value={pk} 
                                                    instantSubmit={true}
                                                    handleChangeFunc={handleChange}
                                                    submitFormFunc={submitForm}
                                                />
                                            </div>
                                        )
                                    })
                                )
                            ) : (
                                ''
                            )}
                        </div>
                        <FieldWrapper label={<Translation id="weischer_activate" />} id="content-title" classes="">
                            <div className="field-checkbox">
                                <label>
                                    <Field
                                        type="checkbox" name="active" onChange={(e) => {handleChange(e); submitForm();}}
                                    />
                                    <span className="text-small-regular">
                                        <Translation id={checkboxLabelTransId} />
                                    </span>
                                </label>
                                <ErrorMessage className="text-regular-color" name="active" component="div" /> 
                            </div>
                        </FieldWrapper>  
                    </fieldset>
                </Form>
            )}

        </Formik>
    )
}


export default withRouter(FormWeischerData) 